import { MEETING_LINK_CONSULTING_QC_EN, MEETING_LINK_CONSULTING_QC_FR, MEETING_LINK_ROADMAP_FR, MEETING_LINK_ROADMAP_QC_EN, MEETING_LINK_ROADMAP_ROC_EN, MEETING_LINK_SDR_ROC_EN, MEETING_LINK_SDR_ROC_FR, } from '../links';
import { isNonProfitOrganization } from './check-company-icp';
export const resolveSmbButton = (selectedLocale, company) => {
    const isEnglish = selectedLocale === 'en';
    const isFromQuebec = company.province === 'QC';
    const isFromRestOfCanada = !isFromQuebec;
    const revenue = company.annual_revenue;
    const isCompanyNPO = isNonProfitOrganization(company.legal_structure || '');
    if (isEnglish) {
        if (isFromQuebec &&
            !isCompanyNPO &&
            (revenue === '100m' || revenue === '100m+')) {
            return {
                title: 'Talk to an expert',
                link: MEETING_LINK_ROADMAP_QC_EN,
            };
        }
        if (isFromQuebec &&
            (revenue === '10m' ||
                revenue === '20m' ||
                revenue === '25m' ||
                revenue === '50m' ||
                revenue === '100m' ||
                revenue === '100m+')) {
            return {
                title: 'Talk to an expert',
                link: MEETING_LINK_CONSULTING_QC_EN,
            };
        }
        if (isFromRestOfCanada &&
            !isCompanyNPO &&
            (revenue === '100m' || revenue === '100m+')) {
            return {
                title: 'Talk to an expert',
                link: MEETING_LINK_ROADMAP_ROC_EN,
            };
        }
        if (isFromRestOfCanada &&
            (revenue === '10m' ||
                revenue === '20m' ||
                revenue === '25m' ||
                revenue === '50m' ||
                revenue === '100m' ||
                revenue === '100m+')) {
            return {
                title: 'Talk to an expert',
                link: MEETING_LINK_SDR_ROC_EN,
            };
        }
        return {
            title: '',
        };
    }
    if (!isCompanyNPO && (revenue === '100m' || revenue === '100m+')) {
        return {
            title: 'Parler à un expert',
            link: MEETING_LINK_ROADMAP_FR,
        };
    }
    if (isFromQuebec &&
        (revenue === '10m' ||
            revenue === '20m' ||
            revenue === '25m' ||
            revenue === '50m' ||
            revenue === '100m' ||
            revenue === '100m+')) {
        return {
            title: 'Parler à un expert',
            link: MEETING_LINK_CONSULTING_QC_FR,
        };
    }
    if (isFromRestOfCanada &&
        (revenue === '10m' ||
            revenue === '20m' ||
            revenue === '25m' ||
            revenue === '50m' ||
            revenue === '100m' ||
            revenue === '100m+')) {
        return {
            title: 'Parler à un expert',
            link: MEETING_LINK_SDR_ROC_FR,
        };
    }
    return {
        title: '',
    };
};
